import React, { Component } from 'react'
import './Legal.css'

class Legal extends Component {
  render() {
    return (
      <div className="legal-container">
        <div className="legal-content-container-header-text">
          <h1 className="legal-content-container-title">
            Embassy Ingredients Ltd. - Annual Report
          </h1>
          <h5 className="legal-content-container-subtitle">
            Fighting Against Forced Labour and Child Labour in Supply Chains
            Act, SC 2023, c 9
          </h5>
        </div>

        <h3 className="legal-subheading color-primary">PURPOSE</h3>
        <p className="legal-paragraph">
          This annual report for the 2026 financial reporting year has been
          created by Embassy Ingredients Ltd. (
          <strong>"Embassy Ingredients"</strong> or the{' '}
          <strong>"Company"</strong>) for the sole purpose of meeting its
          obligations and reporting requirements for entities pursuant to the{' '}
          <em>
            Fighting Against Forced Labour and Child Labour in Supply Chains Act
          </em>
          , SC 2023, c 9 (the <strong>"Act"</strong>). The report outlines the
          approach and initiatives taken by Embassy Ingredients to identify and
          address the risks of forced labour and child labour in its business
          operations and supply chains in the 2026 financial reporting year.
        </p>

        <h3 className="legal-subheading color-primary">COMPANY COMMITMENT</h3>
        <p className="legal-paragraph">
          Embassy Ingredients is committed to preventing and reducing the risk
          that forced labour or child labour is used at any step in the
          production of goods in Canada or elsewhere, including goods that
          Embassy Ingredients imports into Canada.
        </p>

        <h3 className="legal-subheading color-primary">
          STRUCTURE, ACTIVITIES, AND SUPPLY CHAIN
        </h3>
        <p className="legal-paragraph">
          Embassy Ingredients is headquartered in Ontario, Canada, and operates
          within the food manufacturing sector. The Company supplies bakery
          ingredients and flavours, serving commercial bakeries, distributors,
          and foodservice clients.
        </p>

        <h4 className="legal-subsection-heading">The Company's Structure</h4>
        <p className="legal-paragraph">
          Embassy Ingredients is a wholly owned corporation of Xiltrex
          Investments Ltd. Embassy Ingredients does not own or control any
          subsidiaries.
        </p>

        <h4 className="legal-subsection-heading">The Company's Activities</h4>
        <p className="legal-paragraph">
          Embassy Ingredients provides customized bakery ingredients and
          flavours. Its client-specific formulations are tailored to the
          operational environment, allergen requirements, and flavour
          preferences of each customer.
        </p>

        <h4 className="legal-subsection-heading">The Company's Supply Chain</h4>
        <p className="legal-paragraph">
          Embassy Ingredients sources a range of food products and by-products
          primarily from manufacturers and distributors mainly located in Canada
          and the United States. Additionally, some vendors supplying Embassy
          Ingredients are based in countries such as India, Denmark, Belgium,
          China, Austria and Nepal, providing either food-related goods,
          technology solutions, or other services to the Company.
        </p>

        <h3 className="legal-subheading color-primary">
          STEPS TAKEN BY EMBASSY INGREDIENTS IN 2026
        </h3>
        <p className="legal-paragraph">
          To prevent and reduce the risk that forced labour or child labour is
          used at any step of the production of goods in Canada or elsewhere, or
          of goods imported into Canada, Embassy Ingredients maintained policies
          that include, but are not limited to, a Policy Manual and prioritized
          working with temporary worker agencies that have strong labour
          policies in place and commenced requiring new vendors to attest to
          their social responsibility.
        </p>

        <h3 className="legal-subheading color-primary">
          POLICIES AND DUE DILIGENCE PROCESSES
        </h3>
        <p className="legal-paragraph">
          To help prevent and reduce the potential risk that forced labour or
          child labour is used at any step of the production of goods in Canada
          or elsewhere, or of goods imported into Canada, Embassy Ingredients
          implemented and maintained the following policies and due diligence
          processes in 2026:
        </p>

        <div className="legal-list-item">
          <p className="legal-paragraph">
            <strong>a)</strong> The temporary worker agency engaged by Embassy
            Ingredients has an Anti-Child &amp; Anti-Forced Labour Policy which
            enforces a zero tolerance for both Child &amp; Forced labour. Their
            standards follow Canadian labour laws and Bill S-211.
          </p>
        </div>

        <div className="legal-list-item">
          <p className="legal-paragraph">
            <strong>b)</strong> Embassy Ingredients maintains a Policy Manual
            that addresses hours of work by setting a maximum of hours per week
            and by specifying that employees who work beyond the standard
            44-hour workweek prescribed by law will receive the applicable
            overtime rate for all additional hours worked.
          </p>
        </div>

        <div className="legal-list-item">
          <p className="legal-paragraph">
            <strong>c)</strong> During onboarding, Embassy Ingredients requires
            all new employees to present a government-issued identification
            document to confirm their date of birth and to ensure they meet the
            legal minimum age requirement for employment in their jurisdiction.
          </p>
        </div>

        <div className="legal-list-item">
          <p className="legal-paragraph">
            <strong>d)</strong> As part of the vendor approval process, we
            require our vendors to submit a Sustainability Questionnaire. Within
            the questionnaire, the prospective vendor is asked if they comply
            with local laws including fair wages, working hours &amp; no child
            or forced labour.
          </p>
        </div>

        <h3 className="legal-subheading color-primary">
          FORCED LABOUR AND CHILD LABOUR RISKS
        </h3>
        <p className="legal-paragraph">
          Embassy Ingredients has not started the process of identifying the
          risk that child labour and/or forced labour is used in its supply
          chain outside of the initial questionnaire. Embassy Ingredients is
          aware that there may be higher risks associated with certain regions,
          goods, and industries, and intends to explore options for engaging
          with the risk identification process in subsequent reporting years.
        </p>

        <h3 className="legal-subheading color-primary">REMEDIATION MEASURES</h3>
        <p className="legal-paragraph">
          Embassy Ingredients has not identified any forced labour or child
          labour in its activities. As such, it has not undertaken any
          remediation measures.
        </p>

        <h3 className="legal-subheading color-primary">
          REMEDIATION OF LOSS OF INCOME
        </h3>
        <p className="legal-paragraph">
          Embassy Ingredients has not identified any loss of income to
          vulnerable families resulting from measures taken to eliminate the use
          of forced labour or child labour in its activities and supply chains.
          As such, it has not undertaken any remediation measures.
        </p>

        <h3 className="legal-subheading color-primary">
          TRAINING PROVIDED TO EMPLOYEES
        </h3>
        <p className="legal-paragraph">
          In 2026, Embassy Ingredients did not provide training to its employees
          on forced labour or child labour. Moving forward, it will be assessing
          what related training may be appropriate.
        </p>

        <h3 className="legal-subheading color-primary">
          ASSESSING EFFECTIVENESS
        </h3>
        <p className="legal-paragraph">
          Embassy Ingredients does not currently have specific policies and
          procedures in place to assess its effectiveness in reducing and/or
          eliminating the risk of child labour and/or forced labour in its
          supply chain. However, as outlined above, the policies and procedures
          established by Embassy Ingredients, including the Policy Manual, the
          requirement for age verification with a government-issued piece of
          identification during onboarding, the Anti-Child &amp; Anti-Forced
          Labour policy implemented by the temporary worker agency and the
          initial questionnaire to new vendors on their social responsibility,
          help to reduce the risk of child labour and/or forced labour within
          Embassy Ingredients' activities and supply chain.
        </p>

        <h3 className="legal-subheading color-primary">
          APPROVAL AND ATTESTATION
        </h3>
        <p className="legal-paragraph signature">
          In accordance with the requirements of the Act, and in particular
          section 11 thereof, I attest that I have reviewed the information
          contained in the report for the entity listed above. Based on my
          knowledge, and having exercised reasonable diligence, I attest that
          the information in the report is true, accurate and complete in all
          material respects for the purposes of the Act, for the reporting year
          listed above.
        </p>

        <div className="legal-signature-block">
          <p className="legal-signature-name">"Martino Brambilla"</p>
          <hr className="legal-signature-line" />
          <p className="legal-signature-typed">Martino Brambilla</p>
          <p className="legal-signature-typed">President,</p>
          <p className="legal-signature-typed">Embassy Ingredients Ltd.</p>
          <p className="legal-signature-typed">January 22, 2026</p>
          <p className="legal-signature-typed">
            I have authority to bind Embassy Ingredients Ltd.
          </p>
        </div>
      </div>
    )
  }
}

export default Legal
